/**
 * [Draft] Authz V5 
 *  # Introduction  Liste l\'ensemble des services et des opérations disponibles dans le module AUTHZ (Autorisations Pegase).   # Remarques générales sur les APIs  La plupart des opérations de l\'API nécessitent que l\'utilisateur ai le traitement correspondant, sinon elles déclencheront une erreur 403.  Le code du traitement est précisé ce document (dans la description de l\'opération)  Si l\'utilisateur n\'a pas le traitement adéquat, il faudra lui créer une habilitation sur un rôle associé au traitement ad hoc.  # Notions métiers  Le module AUTHZ permet de gérer:  * Utilisateurs * Traitements (voir Autorisation sur les Traitements) * Modules * Actions * Rôles * Habilitations * Périmètres   ## Utilisateurs  Un Utilisateur correspond à une personne ou un automate/service pouvant accèder à l\'application Pegase ou exécuter des traitements de l\'applicatif Pegase.  **Important: Note sur la création des Utilisateurs**  La création des Utilisateurs peut se faire:  * soit via la RDD (Reprise de Données). * soit via l\'applicatif REF (interface utilisateur). * soit via ce service REST /utilisateurs   ## Traitements  Un traitement identifie de manière unique une fonction unitaire de l\'application Pegase.  De manière générale, un traitement correspond à une et une seule API.  Lorsque l\'utilisateur exécute une API, l\'API vérifie que l\'Utilisateur dispose bien du traitement correspondant.  Dans le cas contraire, l\'API lui retournera une erreur (code HTTP 403).  Exemple de traitement: COF_ObjetFormation_Creer (permet de créer un Objet de Formation dans le module COF).  Les traitements sont livrés avec Pegase, il n\'est pas possible d\'en créer des nouveaux.  Par contre, une nouvelle version de Pegase peut ajouter de nouveaux traitements.  Les traitements sont au nombre de quelques centaines.  **Traitement vs Action**      Attention, si l\'API 1 appellée par un utilisateur appelle en interne une autre API (API 2), alors l\'appele ne fonctionnera que si l\'utilisateur dispose des traitements de l\'API 1 **et** de ceux de l\'API 2.  C\'est pour cela que la notion d\'Action a été inventée: une action regroupe l\'ensemble des traitements nécessaire à l\'exécution d\'un acte de gestion.   ## Actions  Une action regroupe l\'ensemble des traitements nécessaire pour réaliser un acte de gestion élémentaire.  Les actes de gestion sont livrés avec Pegase, ils ne peuvent pas être modifiés, supprimés ni créés.  Lorsqu\'un utilisateur souhaite utiliser une fonctionnalité de Pegase, il faut lui associer l\'action correspondante.  Cela se fait en associant l\'action à un rôle, puis en attributant ce rôle à un utilisateur sous la forme dune habilitation.   ## Rôle  Un rôle est un containeur d\'actions.  La notion de Rôle va permettre de regrouper les actions d\'une manière intelligible.  Cela permet de simplifier l\'administration.  L\'administrateur Authz est à même de créer, modifier et supprimer des rôles  Exemple de rôle: \'Gestionnaire de Scolarité\'   ## Habilitations  Une habilitation permet de donner un Rôle à un Utilisateur dans le cadre d\'un Groupe d\'Habilitations.  Nous reviondrons plus tard sur la notion de Groupe d\'Habilitations, pour le moment, on peut le considérer comme un périmètre de données.  Ces habilitations permettent à Pégase d\'effectuer les contrôles d\'accès:  * aux traitements +   Est ce que l\'Utilisateur a le droit d\'exécuter tel Traitement ?  ## Périmètres  Un périmètre d\'habilitation est un ensemble de données sur lequel un utilisateur associé à ce périmètre peut  agir. Dans une 1ere version, le périmètre est constitué d\'un ensemble de Formations. 
 *
 * The version of the OpenAPI document: 27.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AttributionPerimetre } from '../model/attributionPerimetre';
// @ts-ignore
import { Erreurs } from '../model/erreurs';
// @ts-ignore
import { Habilitation } from '../model/habilitation';
// @ts-ignore
import { HabilitationCreation } from '../model/habilitationCreation';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedPerimetresHabilitations } from '../model/pagedPerimetresHabilitations';
// @ts-ignore
import { PagedUtilisateurs } from '../model/pagedUtilisateurs';
// @ts-ignore
import { Utilisateur } from '../model/utilisateur';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class UtilisateursService {

    protected basePath = 'http://localhost:8080/api/authz/autorisation/v5';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Associe un utilisateur à un périmètre d\&#39;habilitation
     * Retourne le périmètre d\&#39;habilitation associé à l\&#39;utilisateur  Traitement nécessaire: AUTHZ_Perimetre_Utilisateur_Associer 
     * @param idUtilisateur Identifiant de l\&#39;utilisateur
     * @param idPerimetre Identifiant du périmètre d\&#39;habilitation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public associerUtilisateurPerimetre(idUtilisateur: string, idPerimetre: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<AttributionPerimetre>;
    public associerUtilisateurPerimetre(idUtilisateur: string, idPerimetre: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<AttributionPerimetre>>;
    public associerUtilisateurPerimetre(idUtilisateur: string, idPerimetre: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<AttributionPerimetre>>;
    public associerUtilisateurPerimetre(idUtilisateur: string, idPerimetre: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (idUtilisateur === null || idUtilisateur === undefined) {
            throw new Error('Required parameter idUtilisateur was null or undefined when calling associerUtilisateurPerimetre.');
        }
        if (idPerimetre === null || idPerimetre === undefined) {
            throw new Error('Required parameter idPerimetre was null or undefined when calling associerUtilisateurPerimetre.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (idPerimetre !== undefined && idPerimetre !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>idPerimetre, 'idPerimetre');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (idTokenAuth) required
        localVarCredential = this.configuration.lookupCredential('idTokenAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/utilisateurs/${this.configuration.encodeParam({name: "idUtilisateur", value: idUtilisateur, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/perimetres`;
        return this.httpClient.request<AttributionPerimetre>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * création d\&#39;un utilisateur ou modification s\&#39;il existe
     * Créer ou modifier un utilisateur  Traitements nécessaires: AUTHZ_Utilisateur_Creer, AUTHZ_Utilisateur_Modifier 
     * @param idUtilisateur Identifiant de l\&#39;utilisateur
     * @param utilisateur L\&#39;utilisateur
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public creerOuModifierUtilisateur(idUtilisateur: string, utilisateur: Utilisateur, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Utilisateur>;
    public creerOuModifierUtilisateur(idUtilisateur: string, utilisateur: Utilisateur, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Utilisateur>>;
    public creerOuModifierUtilisateur(idUtilisateur: string, utilisateur: Utilisateur, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Utilisateur>>;
    public creerOuModifierUtilisateur(idUtilisateur: string, utilisateur: Utilisateur, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (idUtilisateur === null || idUtilisateur === undefined) {
            throw new Error('Required parameter idUtilisateur was null or undefined when calling creerOuModifierUtilisateur.');
        }
        if (utilisateur === null || utilisateur === undefined) {
            throw new Error('Required parameter utilisateur was null or undefined when calling creerOuModifierUtilisateur.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (idTokenAuth) required
        localVarCredential = this.configuration.lookupCredential('idTokenAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/utilisateurs/${this.configuration.encodeParam({name: "idUtilisateur", value: idUtilisateur, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<Utilisateur>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: utilisateur,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dissocier un utilisateur d\&#39;un périmètre d\&#39;habilitation
     * Supprime l\&#39;association périmètre utilisateur  Traitement nécessaire: AUTHZ_Perimetre_Utilisateur_Dissocier 
     * @param idUtilisateur Identifiant de l\&#39;utilisateur
     * @param idPerimetre Identifiant du périmètre d\&#39;habilitation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dissocierUtilisateurPerimetre(idUtilisateur: string, idPerimetre: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public dissocierUtilisateurPerimetre(idUtilisateur: string, idPerimetre: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public dissocierUtilisateurPerimetre(idUtilisateur: string, idPerimetre: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public dissocierUtilisateurPerimetre(idUtilisateur: string, idPerimetre: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (idUtilisateur === null || idUtilisateur === undefined) {
            throw new Error('Required parameter idUtilisateur was null or undefined when calling dissocierUtilisateurPerimetre.');
        }
        if (idPerimetre === null || idPerimetre === undefined) {
            throw new Error('Required parameter idPerimetre was null or undefined when calling dissocierUtilisateurPerimetre.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (idPerimetre !== undefined && idPerimetre !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>idPerimetre, 'idPerimetre');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (idTokenAuth) required
        localVarCredential = this.configuration.lookupCredential('idTokenAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/utilisateurs/${this.configuration.encodeParam({name: "idUtilisateur", value: idUtilisateur, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/perimetres`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * liste des utilisateurs Pegase
     * Retourne une liste paginée de rôles répondant aux critères de recherche  Traitement: AUTHZ_Utilisateur_Lire 
     * @param id identifiant_utilisateur
     * @param nom nom_utilisateur
     * @param prenom prenom_utilisateur
     * @param codesPerimetresIn Liste de codes périmètres inclus, i.e. les périmètres des utilisateurs ont des codes en commun avec codesPerimetresIn
     * @param codesPerimetresOut Liste de codes périmètres exclus, i.e. les périmètres des utilisateurs n\&#39;ont aucun code en commun avec codesPerimetresOut
     * @param pageable Données de pagination.  Le tri sur les colonnes peut se faire sur les propriétés:  * idUtilisateur 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public lireListeUtilisateurs(id?: string, nom?: string, prenom?: string, codesPerimetresIn?: Array<string>, codesPerimetresOut?: Array<string>, pageable?: Pageable, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PagedUtilisateurs>;
    public lireListeUtilisateurs(id?: string, nom?: string, prenom?: string, codesPerimetresIn?: Array<string>, codesPerimetresOut?: Array<string>, pageable?: Pageable, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PagedUtilisateurs>>;
    public lireListeUtilisateurs(id?: string, nom?: string, prenom?: string, codesPerimetresIn?: Array<string>, codesPerimetresOut?: Array<string>, pageable?: Pageable, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PagedUtilisateurs>>;
    public lireListeUtilisateurs(id?: string, nom?: string, prenom?: string, codesPerimetresIn?: Array<string>, codesPerimetresOut?: Array<string>, pageable?: Pageable, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (nom !== undefined && nom !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>nom, 'nom');
        }
        if (prenom !== undefined && prenom !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>prenom, 'prenom');
        }
        if (codesPerimetresIn) {
            codesPerimetresIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'codesPerimetresIn');
            })
        }
        if (codesPerimetresOut) {
            codesPerimetresOut.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'codesPerimetresOut');
            })
        }
        if (pageable !== undefined && pageable !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageable, 'pageable');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (idTokenAuth) required
        localVarCredential = this.configuration.lookupCredential('idTokenAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/utilisateurs`;
        return this.httpClient.request<PagedUtilisateurs>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * liste des habilitations d\&#39;un utilisateur
     * Retourne toutes les habilitations de l\&#39;utilisateur  Traitements nécessaires: AUTHZ_Habilitation_Lire 
     * @param idUtilisateur Identifiant de l\&#39;utilisateur
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listerHabilitationsUtilisateur(idUtilisateur: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<Habilitation>>;
    public listerHabilitationsUtilisateur(idUtilisateur: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<Habilitation>>>;
    public listerHabilitationsUtilisateur(idUtilisateur: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<Habilitation>>>;
    public listerHabilitationsUtilisateur(idUtilisateur: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (idUtilisateur === null || idUtilisateur === undefined) {
            throw new Error('Required parameter idUtilisateur was null or undefined when calling listerHabilitationsUtilisateur.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (idTokenAuth) required
        localVarCredential = this.configuration.lookupCredential('idTokenAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/utilisateurs/${this.configuration.encodeParam({name: "idUtilisateur", value: idUtilisateur, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/habilitations`;
        return this.httpClient.request<Array<Habilitation>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * liste des périmètres d\&#39;un utilisateur
     * Retourne toutes les perimètres d\&#39;habilitation de l\&#39;utilisateur  Traitements nécessaires: AUTHZ_Perimetre_Habilitation_Lire, AUTHZ_Utilisateur_Lire 
     * @param idUtilisateur Identifiant de l\&#39;utilisateur
     * @param pageable Données de pagination.  Le tri sur les colonnes peut se faire sur les propriétés:  * perimetre.code 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listerPerimetresUtilisateur(idUtilisateur: string, pageable?: Pageable, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PagedPerimetresHabilitations>;
    public listerPerimetresUtilisateur(idUtilisateur: string, pageable?: Pageable, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PagedPerimetresHabilitations>>;
    public listerPerimetresUtilisateur(idUtilisateur: string, pageable?: Pageable, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PagedPerimetresHabilitations>>;
    public listerPerimetresUtilisateur(idUtilisateur: string, pageable?: Pageable, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (idUtilisateur === null || idUtilisateur === undefined) {
            throw new Error('Required parameter idUtilisateur was null or undefined when calling listerPerimetresUtilisateur.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (pageable !== undefined && pageable !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageable, 'pageable');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (idTokenAuth) required
        localVarCredential = this.configuration.lookupCredential('idTokenAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/utilisateurs/${this.configuration.encodeParam({name: "idUtilisateur", value: idUtilisateur, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/perimetres`;
        return this.httpClient.request<PagedPerimetresHabilitations>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * modifications des habilitations d\&#39;un utilisateur
     * Les habilitations existantes de l\&#39;utilisateur sont remplacées par celles transmises dans le body 
     * @param idUtilisateur Identifiant de l\&#39;utilisateur
     * @param habilitationCreation 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public modifierHabilitationsUtilisateur(idUtilisateur: string, habilitationCreation: Array<HabilitationCreation>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<Habilitation>>;
    public modifierHabilitationsUtilisateur(idUtilisateur: string, habilitationCreation: Array<HabilitationCreation>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<Habilitation>>>;
    public modifierHabilitationsUtilisateur(idUtilisateur: string, habilitationCreation: Array<HabilitationCreation>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<Habilitation>>>;
    public modifierHabilitationsUtilisateur(idUtilisateur: string, habilitationCreation: Array<HabilitationCreation>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (idUtilisateur === null || idUtilisateur === undefined) {
            throw new Error('Required parameter idUtilisateur was null or undefined when calling modifierHabilitationsUtilisateur.');
        }
        if (habilitationCreation === null || habilitationCreation === undefined) {
            throw new Error('Required parameter habilitationCreation was null or undefined when calling modifierHabilitationsUtilisateur.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (idTokenAuth) required
        localVarCredential = this.configuration.lookupCredential('idTokenAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/utilisateurs/${this.configuration.encodeParam({name: "idUtilisateur", value: idUtilisateur, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/habilitations`;
        return this.httpClient.request<Array<Habilitation>>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: habilitationCreation,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Suppression Utilisateur
     * Suppression Utilisateur by identifiant utilisateur et ces habilitations , temoin livre doit etre false
     * @param idUtilisateur Identifiant de l\&#39;utilisateur
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public suppressionUtilisateur(idUtilisateur: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public suppressionUtilisateur(idUtilisateur: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public suppressionUtilisateur(idUtilisateur: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public suppressionUtilisateur(idUtilisateur: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (idUtilisateur === null || idUtilisateur === undefined) {
            throw new Error('Required parameter idUtilisateur was null or undefined when calling suppressionUtilisateur.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (idTokenAuth) required
        localVarCredential = this.configuration.lookupCredential('idTokenAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/utilisateurs/${this.configuration.encodeParam({name: "idUtilisateur", value: idUtilisateur, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
